import { useQuery } from "@tanstack/react-query";
import {
    CategoryGlMapping,
    categoryContract,
} from "@common/contracts/category.contract";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const categoryContractClient = getBackendAPIClient(categoryContract);

export function useCategoryGlMappings({
    isGlMappingColumnEnabled,
}: {
    isGlMappingColumnEnabled: boolean;
}) {
    const { workspaceId } = useScope();

    if (!workspaceId) {
        throw new Error("No active workspace");
    }

    return useQuery({
        queryKey: ["categoryGlMappings", workspaceId],
        queryFn: () =>
            categoryContractClient.getCategoryGlMappings({
                params: { workspaceId },
            }),
        enabled: isGlMappingColumnEnabled,
    });
}

export function buildCategoryGlMappingsMap(
    mappings: CategoryGlMapping[],
): Map<string, CategoryGlMapping> {
    return new Map(mappings.map((mapping) => [mapping.categoryId, mapping]));
}
